import React, {useState} from "react";
import {Skeleton} from "@material-ui/lab";
import {Post} from '../../../stores/action/Form/Post';
import {useHistory} from "react-router-dom";
import Form from "../../Form/Form";
import FieldBuilder from "../../Form/Fields/FieldBuilder";
import Validation from '../../../stores/action/Form/Validation';
import GroupSubmit from "../../UI/Button/Group/GroupSubmit";
import {Update} from "../../../stores/action/Form/Update";
import {useStore} from "../../../stores/store";
import AccessLevelPositionFields from "./AccessLevelPositionFields";

function getString(id) {
  return id && id !== "create" ? 'Update' : 'Save';
}

function setFields(fields, formik) {
  return <>
    {
      fields && Object.entries(fields).map(([fieldKey, _field]) => {
        return <FieldBuilder
          key={fieldKey}
          field={fieldKey}
          fieldAttributes={fields[fieldKey]}
          validation={formik}
        />
      })
    }
  </>;
}

const AccessLevelPositionForm = (props) => {

  let history = useHistory();
  const {id, data} = props
  const {dispatch} = useStore();
  const [stateLocal, setstateLocal] = useState({});
  const endpoint = (id && id !== "create") ? 'api/v1/access-level-types/' + id : 'api/v1/access-level-types';
  const fields = AccessLevelPositionFields(data);
  const accessLevelPositionCustomFunc = values => (
    id && id !== "create"
      ? Update(dispatch, values, setstateLocal, endpoint, history)
      : Post(dispatch, values, setstateLocal, endpoint, history)
  );

  const formik = Validation(fields, accessLevelPositionCustomFunc);

  return (
    <Form
      stateLocal={stateLocal}
      setstateLocal={setstateLocal}
      className={'fieldHalf'}
      onSubmit={formik.handleSubmit}
    >
      {setFields(fields, formik)}
      {
        fields && Object.entries(fields).length > 0
          ? <GroupSubmit
            className={'GroupSubmit'} reset={false} auto={false} right={true}
            submitText={getString(id)} formik={formik}
          />
          : <Skeleton variant="rect" width={'100%'}/>
      }

    </Form>
  )
}

export default AccessLevelPositionForm;